import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
export var getDefaultStyleSheet = _ref => {
  var {
    designContext,
    disabled,
    dueDate,
    hovered,
    inline,
    isDayLabel,
    keyboardFocused,
    label,
    pressed,
    rangeEnd,
    rangeSelected,
    rangeStart,
    selected,
    withinRange
  } = _ref;
  var dayBorderRadius = designContext.get('date-picker/day-corner-radius').pixelValue;
  var interactiveState = disabled ? 'disabled' : pressed ? 'pressed' : hovered ? 'hovered' : keyboardFocused ? 'keyboardFocused' : 'default';
  var deprecateTextColorTokenExists = designContext.hasTokenInContext('date-picker/text-color');
  return {
    buttonStyle: _objectSpread({
      backgroundColor: designContext.get('colors/backgrounds/transparent').toString(),
      borderColor: designContext.get('colors/borders/transparent').toString(),
      borderWidth: 0,
      outline: 'none',
      width: inline ? '100%' : 40,
      height: inline ? 45 : 40
    }, disabled ? {} : label == null || label === '' ? {} : isDayLabel ? {} : {
      cursor: 'pointer'
    }),
    wrapperStyle: _objectSpread({
      height: isDayLabel ? 40 : inline ? 45 : 40,
      alignItems: 'center',
      position: 'relative'
    }, inline ? {
      flex: 1
    } : {
      width: 40
    }),
    focusStyle: _objectSpread(_objectSpread({
      width: 16,
      height: 2,
      bottom: 8,
      position: 'absolute'
    }, keyboardFocused ? {
      backgroundColor: dueDate ? designContext.get('date-picker/due-date-indicator').toString() : rangeSelected || selected ? designContext.get('date-picker/day-background-color', {
        role: 'default'
      }).toString() : designContext.get('date-picker/day-background-color', {
        role: 'selected'
      }).toString()
    } : {}), {}, {
      transition: 'background-color .2s ease'
    }),
    focusWrapperStyle: {
      position: 'absolute',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      zIndex: 2,
      alignItems: 'center'
    },
    todayStyle: {
      width: inline ? 45 : 40,
      height: inline ? 45 : 40,
      borderRadius: dayBorderRadius,
      borderWidth: 2,
      boxSizing: 'border-box',
      borderColor: dueDate ? designContext.get('date-picker/due-date-indicator').toString() : selected ? designContext.get('date-picker/today-border-color', {
        role: 'selected'
      }).toString() : designContext.get('date-picker/today-border-color').toString(),
      borderStyle: 'solid',
      transition: 'border-color .2s ease'
    },
    todayWrapperStyle: {
      position: 'absolute',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      zIndex: 2,
      alignItems: 'center'
    },
    dueDateIndicatorWrapperStyle: {
      position: 'absolute',
      left: 0,
      top: 0,
      right: 0,
      bottom: 0,
      width: '100%',
      height: '100%',
      zIndex: 2,
      paddingTop: inline ? 38 : 33,
      alignItems: 'center'
    },
    colorizerStyle: {
      width: inline ? 45 : 40,
      height: inline ? 45 : 40,
      justifyContent: 'center',
      borderRadius: dayBorderRadius,
      backgroundColor: designContext.get('date-picker/day-background-color', {
        interactiveState: isDayLabel || !label ? 'default' : interactiveState,
        role: selected ? 'selected' : rangeSelected ? 'rangeSelected' : withinRange || rangeStart || rangeEnd ? 'idle' : 'default',
        dueDate: dueDate ? 'dueDate' : 'default'
      }).toString(),
      zIndex: 1
    },
    dueDateIndicatorStyle: _objectSpread(_objectSpread({
      width: 6,
      height: 6,
      borderRadius: dayBorderRadius,
      top: -3
    }, dueDate && !keyboardFocused ? {
      backgroundColor: designContext.get('date-picker/due-date-indicator', {
        interactiveState: disabled ? 'disabled' : 'default'
      }).toString()
    } : {}), {}, {
      transition: 'background-color .2s ease'
    }),
    leftSideBackgroundStyle: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: inline ? '50%' : 20,
      height: inline ? 45 : 40,
      backgroundColor: designContext.get('date-picker/day-background-color', {
        role: rangeSelected && !rangeStart ? 'rangeSelected' : (withinRange || rangeEnd) && !rangeStart ? 'idle' : 'default'
      }).toString()
    },
    rightSideBackgroundStyle: {
      position: 'absolute',
      top: 0,
      right: 0,
      width: inline ? '50%' : 20,
      height: inline ? 45 : 40,
      backgroundColor: designContext.get('date-picker/day-background-color', {
        role: rangeSelected && !rangeEnd ? 'rangeSelected' : (withinRange || rangeStart) && !rangeEnd ? 'idle' : 'default'
      }).toString()
    },
    dayNumberStyle: _objectSpread(_objectSpread({
      color: deprecateTextColorTokenExists ? designContext.get('date-picker/text-color', {
        role: selected || rangeSelected ? 'selected' : 'default',
        interactiveState: disabled ? 'disabled' : 'default'
      }).toString() : designContext.get('date-picker/day-text-color', {
        state: selected || rangeSelected ? 'selected' : 'default',
        interactiveState
      }).toString()
    }, designContext.get('date-picker/day-text-style').styles()), {}, {
      margin: 0,
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'center',
      wordBreak: 'break-word'
    }),
    weekdayLabelStyle: _objectSpread(_objectSpread({
      color: deprecateTextColorTokenExists ? designContext.get('date-picker/text-color', {
        role: 'day'
      }).toString() : designContext.get('date-picker/weekday-text-color').toString()
    }, designContext.get('date-picker/weekday-text-style').styles()), {}, {
      margin: 0,
      textRendering: 'geometricPrecision',
      WebkitFontSmoothing: 'antialiased',
      textAlign: 'center',
      wordBreak: 'break-word'
    })
  };
};
//# sourceMappingURL=getDefaultStyleSheet.js.map